import { useEffect } from "react";
import { useMotionTemplate, useSpring, useTransform } from "framer-motion";
import { purple, white } from "tailwindcss/colors";
import { interpolate } from "flubber";
import { Props } from "./PanKnob";
import { useMountEffect } from "@react-hookz/web";

export default function useSvgBlobAnimations({ pan, width }: Props) {
  const spring = useSpring(pan, {
    duration: 0,
    damping: 0,
    bounce: 1,
  });

  useEffect(() => {
    spring.set(pan);
  }, [pan, spring]);

  const leftD =
    "M58,-46.1C70.9,-30.1,74.1,-6.2,69.6,16.8C65.1,39.9,52.9,62.2,37.2,65.1C21.5,68,2.3,51.6,-19.2,40.9C-40.6,30.2,-64.3,25.1,-72.6,10.4C-80.9,-4.3,-73.8,-28.8,-59.2,-45.1C-44.5,-61.5,-22.2,-69.8,0.2,-70C22.6,-70.1,45.2,-62.1,58,-46.1Z";
  const rightD =
    "M41.4,-35.1C54.2,-16.9,65.7,0.4,65.5,20.4C65.2,40.4,53.3,63.2,35.2,71.1C17.1,79,-7.2,72.2,-30.2,61.5C-53.3,50.9,-75.1,36.5,-80.2,17.4C-85.3,-1.7,-73.7,-25.6,-57.5,-44.6C-41.3,-63.6,-20.7,-77.7,-3.2,-75.1C14.3,-72.6,28.5,-53.3,41.4,-35.1Z";
  const center =
    "M65.9,-21.5C75,6.5,64.8,40.8,41.6,57.7C18.5,74.6,-17.5,74.1,-41.5,56.7C-65.6,39.4,-77.7,5.1,-68.8,-22.8C-59.9,-50.6,-29.9,-72,-0.8,-71.8C28.4,-71.5,56.8,-49.6,65.9,-21.5Z";

  const d = useTransform(spring, [-90, 90], [0, 1], {
    mixer: (a, b) => {
      return (x) => {
        if (x <= 0) {
          x = 0;
        }

        if (x >= 1) {
          x = 1;
        }

        if (x <= 0.5) {
          return interpolate(leftD, center)(Math.abs(x) * 2);
        }

        return interpolate(center, rightD)((x - 0.5) * 2);
      };
    },
  });
  const translateTransformed = useTransform(
    spring,
    [-90, 90],
    [-width * 0.2, width * 0.2]
  );
  const translateX = useMotionTemplate`translateX(${translateTransformed}px)`;
  const fill = useTransform(
    spring,
    [-90, 0, 90],
    [purple[500], "#000", purple[500]]
  );
  const stroke = useTransform(
    spring,
    [-15, 0, 15],
    [purple[500], white, purple[500]]
  );

  return {
    d,
    translateX,
    fill,
    stroke,
  };
}
